import React, { useState } from 'react';
import { branch, compose, renderComponent, withProps } from 'recompose';
import withNickname from './withNickname';
import Nickname from '.';

export default compose(
    withProps(() => {
        const [nicknameRequestComplete, setNicknameRequestComplete] = useState(false);
        const onNicknameSet = () => { setNicknameRequestComplete(false); };
        return {
            onNicknameSet,
            nicknameRequestComplete,
            setNicknameRequestComplete
        };
    }),
    withNickname,
    branch(
        ({ joined, nicknameDetails, isToUseUsername, displaySetNickname = true }) => {
            if (isToUseUsername) {
                return false;
            }

            return !joined && nicknameDetails && displaySetNickname && !nicknameDetails.casinoNickname;
        },
        renderComponent(({ leaderboardId, onNicknameSet, nicknameDetails, useTournament }) => (
            <Nickname {...{ leaderboardId, onNicknameSet, nicknameDetails, useTournament }} />
        ))
    )
);
